/* Roast Row delivery estimate: dates from the SHIPPING POLICY (US 1-3 + 3-7 business days; CA/UK 1-3 + 7-14).
   Holidays / cut-off from the product metafield when present. No personal data is stored. */
(function () {
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var DOW = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var REGION = { 'Alaska': 'AK', 'Hawaii': 'HI', 'Puerto Rico': 'PR', 'Guam': 'GU', 'Virgin Islands': 'VI' };

  function partsIn(tz) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false });
    var o = {}; f.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { date: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)), minutes: (+o.hour % 24) * 60 + (+o.minute) };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function isBiz(d, hol) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && hol.indexOf(iso(d)) === -1; }
  function addBiz(d, n, hol) { d = new Date(d); while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (isBiz(d, hol)) n--; } return d; }
  var ES = (document.documentElement.lang || '').slice(0, 2) === 'es';
  var DOW_ES = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'], MON_ES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  function fmt(d) { return ES ? DOW_ES[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MON_ES[d.getUTCMonth()]
                              : DOW[d.getUTCDay()] + ', ' + MON[d.getUTCMonth()] + ' ' + d.getUTCDate(); }

  // Owner 2026-10-11: the estimate follows the shipping policy (Google Merchant Center must match the page):
  // US 1-3 business days processing + 3-7 in transit; Canada / UK 1-3 + 7-14. Same for every product.
  var POLICY = { US: { proc: [1, 3], transit: [3, 7] }, CA: { proc: [1, 3], transit: [7, 14] }, UK: { proc: [1, 3], transit: [7, 14] } };
  function render(el, cfg, region) {
    var country = (el.getAttribute('data-country') || 'US').toUpperCase();
    var market = country === 'GB' ? 'UK' : country;
    var pol = POLICY[market]; if (!pol) return;                  // other countries: keep the server text
    // Honest origin: a product whose supplier stock is in China keeps China's real carrier times (owner: never hide it).
    var m = ((cfg || {}).markets || {})[market];
    if (m && m.origin === 'CN' && m.transit) {
      var pc = ((cfg.processing || {}).CN != null) ? cfg.processing.CN : 2;
      pol = { proc: [1, Math.max(1, pc)], transit: m.transit };
    }
    var text = el.querySelector('[data-rr-delivery-text]');
    cfg = cfg || {};
    var hol = cfg.holidays || [], now = partsIn(cfg.tz || 'America/Los_Angeles');
    var cut = (cfg.cutoff || '12:00').split(':'), start = now.date;
    if (now.minutes >= (+cut[0]) * 60 + (+cut[1]) || !isBiz(start, hol)) start = addBiz(start, 1, hol);
    var extra = market === 'US' ? ((cfg.extra_region || {})[region] || 0) : 0;
    var a = addBiz(start, pol.proc[0] + pol.transit[0] + extra, hol), b = addBiz(start, pol.proc[1] + pol.transit[1] + extra, hol);
    text.textContent = (ES ? 'Entrega estimada ' : 'Estimated delivery ') + fmt(a) + ' – ' + fmt(b);
  }

  function init() {
    var el = document.querySelector('[data-rr-delivery]'); if (!el) return;
    var cfg; try { cfg = JSON.parse(el.getAttribute('data-rr-delivery')); } catch (e) { return; }
    render(el, cfg, null);
    // Only the region matters (Alaska/Hawaii/territories add days). Lightweight lookup, 1.5 s budget, nothing stored.
    if ((el.getAttribute('data-country') || 'US').toUpperCase() !== 'US' || !window.fetch) return;
    var ctl = window.AbortController ? new AbortController() : null;
    if (ctl) setTimeout(function () { ctl.abort(); }, 1500);
    fetch('https://get.geojs.io/v1/ip/geo.json', ctl ? { signal: ctl.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (g) { var reg = REGION[g.region]; if (reg) render(el, cfg, reg); })
      .catch(function () {});
  }
  if ('requestIdleCallback' in window) requestIdleCallback(init, { timeout: 1200 }); else setTimeout(init, 300);
})();
